import React, { Component } from "react";

export default class NoResults extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return <div className="loader">Geen resultaten gevonden.</div>;
    }
}
